import { AxiosConfig } from "../AxiosConfig/AxiosConfig";
const getGraphToken = (scopes) => new Promise(async (resolve) => {
    const encodeQuery = encodeURIComponent(scopes);
    const t = setTimeout(() => {
        window.location.reload();
    }, 10000);
    AxiosConfig.instance.get("/graphtoken?scopesStr=" + encodeQuery).then(res => { clearTimeout(t); return resolve(res.data); }).catch(e => { clearTimeout(t); return resolve(null); });
});
const saveToken = () => new Promise(async (resolve) => {
    try {
        await AxiosConfig.instance.get("/StoreToken");
        return resolve();
    }
    catch (_) {
        console.error("Can't save token");
        return resolve();
    }
});
export const TokenApi = {
    saveToken,
    getGraphToken,
};
